import { render } from "./Logout.vue?vue&type=template&id=867c34fa"
import script from "./Logout.vue?vue&type=script&lang=ts"
export * from "./Logout.vue?vue&type=script&lang=ts"
script.render = render

export default script